import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';

import { UXFB_CLIENT_EVENTS_CONFIG_KEY, UXFB_EVENT_OPEN_DEVELOPER_CATALOG, UXFB_PLATFORM } from '../../constants/uxfb';
import { useApplicationContext } from '../../utils/applicationContext';
import { sendUXSEventWhenReady } from '../../utils/uxs';

/**
 * Шлёт UXFB-событие `open_developer_catalog` один раз при заходе в каталог застройщиков (mount).
 * По сценарию событие только десктопное, на других устройствах не отправляется.
 *
 * `dedupeKey` обязателен: useRef не переживает ремаунт контейнера, дубль события засчитывается
 * бэкендом UXFB как лишний «заход», и кампании «на 2-й заход» выезжают уже на первом.
 */
export function useOpenDeveloperCatalogUxfbEvent(): void {
  const { config } = useApplicationContext();
  const deviceType = useDeviceType();

  React.useEffect(() => {
    if (deviceType !== 'desktop' || config.get<boolean>(UXFB_CLIENT_EVENTS_CONFIG_KEY) === false) {
      return;
    }

    sendUXSEventWhenReady(
      UXFB_EVENT_OPEN_DEVELOPER_CATALOG,
      { platform: UXFB_PLATFORM },
      { dedupeKey: UXFB_EVENT_OPEN_DEVELOPER_CATALOG },
    );
  }, [config, deviceType]);
}
